exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{@page{size:landscape}body{overflow:auto;height:auto}.scroll-y{height:auto;overflow:visible}.v-navigation-drawer,footer.v-footer,nav.v-toolbar{display:none}main.v-content{padding:20px!important}.report-container{width:100%!important}.elevation-2,.v-card{-webkit-box-shadow:none!important;box-shadow:none!important}.question-card{border:1px solid grey!important;-webkit-column-break-inside:avoid;page-break-inside:avoid;break-inside:avoid}}a.v-tabs__item:hover{text-decoration:none!important;font-weight:bolder}.v-chip{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e5f9210","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/assembly/virtualreport.vue
// module id = lz6M
// module chunks = 2